import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FieldAdminPage } from '../../components/field/FieldAdminPage';

/**
 * /field — তালিকা ব্যবস্থাপনা / LIST MANAGEMENT
 *
 * 3-tab admin shell per Phase 0.7 / §3.6 / §3.7 of taxonomy-crud-umbrella.md.
 *
 * Search-param schema:
 *   tab          — active tab (browse | structure | standalone). Default: browse.
 *   subtab       — STANDALONE FIELDS sub-tab. Default: type.
 *   field        — entity kind navigated to via cmd-K (unchanged from v1 contract).
 *   curriculumId / versionId / classId / subjectId / chapterId / topicId — entity context params.
 *   typeId — flat-entity context param.
 *
 * All params are optional so existing cmd-K callers (navigateToTaxonomy in
 * command-palette/lib/nav.ts) land cleanly after it adds ?tab=browse|standalone.
 */
const fieldSearchSchema = z.object({
  // --- new: active tab (Phase 0.7 shell) ---
  tab: z.enum(['browse', 'structure', 'standalone']).optional(),
  // --- new: STANDALONE FIELDS sub-tab (Wave 5a shell) ---
  subtab: z.enum(['type', 'tag', 'level']).optional(),
  // --- archive overlay toggle (true-or-absent; junk URL values degrade to off, never throw) ---
  showArchived: z
    .union([z.boolean(), z.string(), z.number()])
    .optional()
    .catch(undefined)
    .transform((v) => (v === true || v === 'true' || v === 1 ? true : undefined)),
  // --- unchanged: entity-context params from v1 (cmd-K compat) ---
  field: z.string().optional(),
  curriculumId: z.coerce.number().optional(),
  versionId: z.coerce.number().optional(),
  classId: z.coerce.number().optional(),
  subjectId: z.coerce.number().optional(),
  chapterId: z.coerce.number().optional(),
  topicId: z.coerce.number().optional(),
  typeId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_admin/field')({
  validateSearch: fieldSearchSchema,
  component: FieldRoute,
});

function FieldRoute() {
  return <FieldAdminPage />;
}
